import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PendingConsentsList.css';
import _ from 'lodash';
import IconContainer from '../../../commonComponents/iconContainer/IconContainer';
import {Table} from 'reactstrap';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import {Redirect} from 'react-router-dom';
import PaginationPendingConsents from '../../../commonComponents/paginationComponent/PaginationPendingConsents.container';

class PendingConsentsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to='/approve-consent' push/>
            );
        }


        return (
            <div className='pending-consents-list-container'>
                <h4 className='page-label'>{_.get(this.props.translation, 'consents.pending_consents_label')}</h4>
                <PaginationPendingConsents/>
                {this.renderTable()}
            </div>
        );
    }

    renderTable = () => {
        if (this.props.loading) {
            return (
                <div className="pending-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="pending-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'consents.no_pending_consents_label')}</h6>
                </div>
            );
        }

        return (
            <Table className='pending-consents-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'consents.person_label')}</th>
                    <th>{_.get(this.props.translation, 'consents.job_label')}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.company_label)}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderPendingConsentsData()}
                </tbody>
            </Table>
        )
    };

    renderPendingConsentsData = () => {
        return _.map(this.props.data, (consentData, index) => (
            <tr className="pending-consents-list-row" key={index} onClick={this.handleClick(consentData.id)}>
                <td className='person-td' data-th={_.get(this.props.translation, 'consents.person_label') + ':'}>{this.renderPersonName(consentData)}</td>
                <td className='job-td' data-th={_.get(this.props.translation, 'consents.job_label') + ':'}>{consentData.jobTitle}</td>
                <td className='company-td' data-th={_.get(this.props.translation, sharedLabelsPath.company_label) + ':'}>
                    {consentData.companyName ? consentData.companyName + ", " + _.get(this.props.translation, 'countries.' + consentData.countryCode) : '-'}
                </td>
                <td className='email-td' data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ':'}>
                    {consentData.email ? (<a onClick={this.handleEmailLinkClick} href={"mailto:" + consentData.email}>{consentData.email}</a>) : '-'}
                </td>
                <td className="control-cell edit-pending-consent-icon-td"
                    onClick={this.handleClick(consentData.id)}>
                    <IconContainer
                        key={index}
                        icon='create'
                        className="edit-pending-consent-icon"
                        title={_.get(this.props.translation, 'consents.edit_label')}
                    />
                </td>
            </tr>
        ))
    };

    renderPersonName = (consentData) => {
        if (_.isNil(consentData.firstName) && _.isNil(consentData.lastName)) {
            return '-';
        } else if (_.isNil(consentData.firstName) && !_.isNil(consentData.lastName)) {
            return consentData.lastName;
        } else if (!_.isNil(consentData.firstName) && _.isNil(consentData.lastName)) {
            return consentData.firstName;
        } else {
            return consentData.firstName + ' ' + consentData.lastName;
        }
    };

    handleEmailLinkClick = (e) => {
        e.stopPropagation();
    };

    handleClick = (id) => () => {
        this.setState({
            redirect: true
        });
        this.props.onStateConsentsProcessing(id);
    };
}

PendingConsentsList.propTypes = {
    translation: PropTypes.object.isRequired,
    data: PropTypes.array,
    onMount: PropTypes.func,
    onStateConsentsProcessing: PropTypes.func
};

export default PendingConsentsList;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/pendingConsentsList/PendingConsentsList.js